define(['jquery',
        'core/urls',
        'components/selectize'],
    function($, urls, selectize_util) {
        let nps_check = $('input[name="nps"]');
        let csat_check = $('input[name="csat"]');
        let csat_group = $('#csat-group');
        let csat_group_filters = $('#csat-group-filters');
        let nps_group = $('#nps-group');
        let nps_group_filters = $('#nps-group-filters');
        let submit_button = $('input[type="submit"]');
        let csatComment = $('input[name="csat_filter_comments"]');
        let csatMaketingPermissions = $('input[name="csat_filter_mp"]');
        let npsComment = $('input[name="nps_filter_comments"]');
        let npsMaketingPermissions = $('input[name="nps_filter_mp"]');

        function updateForm() {
            let csatChecked = csat_check.prop('checked');
            let npsChecked = nps_check.prop('checked');
            
            if(!csatChecked && !npsChecked) {
                submit_button.prop('disabled', true).addClass("disabled");
            } else {
                submit_button.prop('disabled', false).removeClass("disabled");                
            }

            if(!csatChecked) {
                csat_group_filters.addClass("hide");
                csat_group.addClass("hide");
            } else {
                csat_group_filters.removeClass("hide");
                csat_group.removeClass("hide");
            }

            if(!npsChecked) {
                nps_group_filters.addClass("hide");
                nps_group.addClass("hide");
            } else {
                nps_group_filters.removeClass("hide");
                nps_group.removeClass("hide");
            }

            csat_group.prop("disabled", !csat_check.prop('checked'));
            nps_group.prop("disabled", !nps_check.prop('checked'));
        }

        let renderCheck = setInterval(() => {
            let selectizedElement = document.querySelector(".selectize-control");
            if (selectizedElement) {
                document.querySelectorAll(".group-wrapper.hide").forEach(el => {
                    el.classList.remove("hide");
                })
                clearInterval(renderCheck);
            }
        }, 100);
       
        return {
            init: function() {

                renderCheck;

                updateForm();
                $('input[name="nps"],input[name="csat"]').on('change', function (e) {
                    updateForm();
                });               

                if(csatComment.prop('checked')){
                    csatMaketingPermissions.parent().removeClass("disabled");
                }

                if(npsComment.prop('checked')){
                    npsMaketingPermissions.parent().removeClass("disabled");
                }

                csatComment.on('change', function (e) {
                    if(csatComment.prop('checked')){
                        csatMaketingPermissions.parent().removeClass("disabled");
                    } else {
                        csatMaketingPermissions.parent().addClass("disabled");
                        csatMaketingPermissions.prop('checked', false)
                    }
                });

                npsComment.on('change', function (e) {
                    if(npsComment.prop('checked')){
                        npsMaketingPermissions.parent().removeClass("disabled");
                    } else {
                        npsMaketingPermissions.parent().addClass("disabled");
                        npsMaketingPermissions.prop('checked', false)
                    }
                });
            }
        };
    }
);
